<splash-screen></splash-screen>
<router-outlet />
